import has from "lodash/has";
import isObject from "lodash/isObject";
import isPlainObject from "lodash/isPlainObject";
import values from "lodash/values";
import { AvailabilityRuleV2 } from "PFTypes/availability";
import {
  DateRangesValueV2,
  DateRangeV2,
  FilterOptionV2,
  FilterTypeV2,
  FilterV2,
  FilterValueV2,
  NumericRangeValueV2,
  OptionsFilterV2,
  PeriodRangeValueV2
} from "PFTypes/filters_v2";

export const isDateWithRangesValueV2 = (value: any): value is DateRangesValueV2 =>
  value && isPlainObject(value) && "mode" in value && "ranges" in value;

export const isDateWithSingleRangeValueV2 = (value: any): value is DateRangeV2 | PeriodRangeValueV2 =>
  value && isPlainObject(value) && "start" in value && "end" in value;

export const isFilterValueIntegerRangeV2 = (
  filterValue: FilterValueV2 | undefined
): filterValue is NumericRangeValueV2 => has(filterValue, "lte") || has(filterValue, "gte");

export const isFilterValueOptionV2 = (value: any): value is FilterOptionV2 =>
  has(value, "id") && has(value, "text");

export const isOptionsFilterV2 = (filter: FilterV2): filter is OptionsFilterV2 => has(filter, "options");

export const isFilterV2 = (filter: any): filter is FilterV2 =>
  has(filter, "type") && values(FilterTypeV2).includes(filter.type);

export const isAvailabilityRuleV2 = (value: any): value is AvailabilityRuleV2 =>
  value && isObject(value) && "mode" in value && "ranges" in value && "availabilityThreshold" in value;
